import React from "react";
import { assets } from "../../../assets/assets";
import "./style/itemNav.css";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
import { useLocation } from "react-router-dom";
import FilterMaster from "../../modal/FilterNav/FilterMaster";
import FilterHome from "../../modal/FilterNav/FilterHome";

function ItemNav({
  onCallbackClick,
  onShowRadiusClick,
  className,
  hideShowRadius,
  lang,
  btnLang,
  onToggleOverlay,
  isOverlayHidden,
  onToggleFilter,
  isBottomNav = false,
  isFilterOpen,
  // onFilterChange,
  onLandmarksClick,
  onRoadsClick,
  showPlaces,
  showRoads,
  isDevsActive,
  onDevsClick,
  setFilterSelection,
  setProgressVilla,
  setSpinVilla,
  isExploreTour,
}) {
  const location = useLocation();
  const page = location?.pathname || "";

  const translations = lang === "ar" ? ar : en;

  const isTourPage = page.includes("/tour/");
  // إذا كانت isExploreTour بتيجي كـ prop فهي بتغطي حالة الإكسبلور
  const hideOverlayButton = isExploreTour || isTourPage;
  //  العناصر الأساسية
  let navLinks = [
    {
      icon: assets.sms,
      label: translations.callback,
      onClick: onCallbackClick,
    },
    ...(!hideOverlayButton
      ? [
          {
            icon: assets.hide,
            label: isOverlayHidden
              ? translations.showOverlay
              : translations.hideOverlay,
            onClick: onToggleOverlay,
          },
        ]
      : []),
    ...(page === "/" && !isBottomNav
      ? [
          {
            icon: assets.showRadius,
            label: hideShowRadius
              ? translations.hideRadius
              : translations.showRadius,
            onClick: onShowRadiusClick,
          },
        ]
      : []),

    {
      isLangButton: true,
      label: translations.changeLang,
      onClick: btnLang,
    },
  ];
  const isMasterMainPage =
    page.includes("/master-plan") && !page.includes("/tour/");

  const shouldShowFilter =
    isBottomNav && (page === "/" || (isMasterMainPage && !isExploreTour));

  const isMaster = isMasterMainPage;
  const isHome = page === "/";

  if (shouldShowFilter) {
    navLinks.splice(navLinks.length - 2, 0, {
      icon: assets.settingFilter,
      label: translations.filter,
      onClick: (e) => {
        e.preventDefault();
        onToggleFilter && onToggleFilter();
      },
    });
  }
  const dir = lang === "ar" ? "rtl" : "ltr";
  // const isMaster = page?.startsWith("/master-plan");
  // const isHome = page === "/";
  return (
    <div
      className="navbar-collapse justify-content-center"
      id="navbarSupportedContent"
    >
      <ul
        className={`navbar-nav text-center mx-auto mb-lg-0 p-0 ${className || ""}`}
        dir={dir}
        lang={lang}
      >
        {navLinks.map((item, index) => (
          <li
            className="nav-item p-0"
            key={index}
            style={{ position: "relative" }}
          >
            <a
              className="nav-link active"
              href="#"
              data-text={item.label}
              onClick={(e) => {
                e.preventDefault();
                item.onClick && item.onClick(e);
              }}
            >
              {item.isLangButton ? (
                <span>{lang === "ar" ? "EN" : "AR"}</span>
              ) : (
                <img src={item.icon} alt={item.label} />
              )}
            </a>
          </li>
        ))}
      </ul>

      {/* 👇 فصلنا الفلتر خارج الـ map تمامًا */}
      {/* {isBottomNav && (page === "/" || page.startsWith("/master-plan")) && ( */}
      {isBottomNav &&
        !page.includes("/tour/") &&
        !page.includes("/villa/") &&
        (page === "/" || page.includes("/master-plan")) && (
          <div className="filter-wrapper col-12 d-flex justify-content-center">
            {isMaster ? (
              <FilterMaster
                isOpen={isFilterOpen}
                lang={lang}
                setFilterSelection={setFilterSelection}
                setProgressVilla={setProgressVilla}
                setSpinVilla={setSpinVilla}
              />
            ) : isHome ? (
              <FilterHome
                lang={lang}
                isOpen={isFilterOpen}
                onLandmarksClick={onLandmarksClick}
                onRoadsClick={onRoadsClick}
                showPlaces={showPlaces}
                showRoads={showRoads}
                onShowRadiusClick={onShowRadiusClick}
                hideShowRadius={hideShowRadius}
                isDevsActive={isDevsActive}
                onDevsClick={onDevsClick}
              />
            ) : null}
          </div>
        )}
    </div>
  );
}

export default ItemNav;
